import React, { useEffect } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuthStore } from '@/store/authStore';
import { useFamilyStore } from '@/store/familyStore';
import { useProfiles } from './hooks/useProfiles';
import { ProfileCard } from './components/ProfileCard';
import { ProfileDialog } from './components/ProfileDialog';
import { DeleteProfileDialog } from './components/DeleteProfileDialog';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';

export function Profiles() {
  const user = useAuthStore((state) => state.user);
  const { personalInfos, isLoading, error, fetchPersonalInfos } = useFamilyStore();
  const {
    showAddDialog,
    setShowAddDialog,
    editingProfile,
    setEditingProfile,
    deletingProfile,
    setDeletingProfile,
    handleAdd,
    handleEdit,
    handleDelete,
  } = useProfiles();

  const isAdmin = user?.role === 'admin';

  // Fetch personal info when component mounts
  useEffect(() => {
    console.log({editingProfile})
    fetchPersonalInfos();
  }, [fetchPersonalInfos]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center p-8 bg-white rounded-lg shadow-sm">
        <p className="text-red-500">{error}</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold text-gray-900">الأرشيف</h2>
        {isAdmin && (
          <Button onClick={() => setShowAddDialog(true)} className="hover:bg-secondary">
            <Plus className="h-4 w-4 ml-2" />
            إضافة من أنت 
          </Button>
        )}
      </div>

      <div className="space-y-4">
        {personalInfos.length === 0 ? (
          <div className="text-center p-8 bg-white rounded-lg shadow-sm">
            <p className="text-gray-500">لا توجد ملفات شخصية حالياً</p>
          </div>
        ) : (
          personalInfos.map((profile) => (
            <ProfileCard
              key={profile.id}
              profile={profile}
              isAdmin={isAdmin}
              onEdit={() => setEditingProfile(profile)}
              onDelete={() => setDeletingProfile(profile)}
            />
          ))
        )}
      </div>

      {showAddDialog && (
        <ProfileDialog
          open={true}
          onClose={() => setShowAddDialog(false)}
          onSubmit={handleAdd}
          mode="add"
        />
      )}

      {editingProfile && (
        <ProfileDialog
          open={true}
          onClose={() => setEditingProfile(null)}
          onSubmit={handleEdit}
          initialData={editingProfile}
          mode="edit"
        />
      )}

      {deletingProfile && (
        <DeleteProfileDialog
          open={true}
          onClose={() => setDeletingProfile(null)}
          onConfirm={handleDelete}
          profileName={deletingProfile.fullName}
        />
      )}
    </div>
  );
}